import React from 'react'
import { ModalRouter } from 'experienceComponents/CreateInstanceShared'

const CreateCourseModalRouter = props => {
  return <ModalRouter {...props} componentType="course" />
}

export default CreateCourseModalRouter
